import script from "./SidebarPlaylists.vue?vue&type=script&setup=true&lang=js"
export * from "./SidebarPlaylists.vue?vue&type=script&setup=true&lang=js"

import "./SidebarPlaylists.vue?vue&type=style&index=0&id=2fd79323&scoped=true&lang=css"

import exportComponent from "/home/runner/work/musora-web-platform/musora-web-platform/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2fd79323"]])

export default __exports__